import * as L from "leaflet";
import axios, { AxiosPromise } from "axios";
import config from "../config";
import { IAccessToken } from "../redux/modules/auth/reducer";
import { originHash } from "../utils/getOriginHash";

export default class S3TileAccessLayer extends L.TileLayer {
  constructor(
    tilesUrl: string,
    options: L.TileLayerOptions,
    private accessToken: IAccessToken,
  ) {
    super(tilesUrl, options);
    L.Util.setOptions(this, options);
  }

  public updateAccessToken(accessToken: IAccessToken) {
    this.accessToken = accessToken;
  }

  public getTileUrl(tilePoint: L.Point) {
    // HACK: getTileUrl is private; don't want to copy it's contents, see
    // https://github.com/Leaflet/Leaflet/blob/master/src/layer/tile/TileLayer.js#L158
    const sup = L.TileLayer.prototype as any;
    const tilePath = sup.getTileUrl.call(this, tilePoint);
    return `${config.endpoints.backofficeStorage}/tiles/${tilePath}?hash=${originHash}`;
  }

  public createTile(coords: L.Coords, done: L.DoneCallback): HTMLElement {
    const url = this.getTileUrl(coords);
    const req: AxiosPromise = axios.get(url, {
      responseType: "blob",
      headers: {
        "Content-Type": "image/png",
        Authorization: `Bearer ${this.accessToken}`,
      },
    });

    const img = new Image();
    req
      .then((res) => {
        img.src = URL.createObjectURL(res.data);
        // @ts-ignore
        this._tileOnLoad(done, img);
      })
      .catch(
        // @ts-ignore
        (error) => this._tileOnError(done, img, error),
      );

    return img;
  }
}
